<template>
  <div class="layout-header">
    <div class="top-0 left-0 justify-center w-full bg-white headershadow" style="z-index: 1000">
      <div class="flex items-center justify-center" style="background: rgb(245 245 245)">
      </div>
      <div class="flex justify-center">
        <div class="flex justify-between w-9/12">
          <div class="flex mt-2 mb-2">
            <img
              src="@/assets/images/logo.jpg"
              class="float-left mt-5"
              style="height: 60px"
              @click="clickSilder('#col')"
            />
            <div
              class="float-left pt-5 pl-6 mb-2 text-2xl font-medium text-black text-neutral-800"
              style="color: rgb(64 64 64); min-width: 336px"
            >
              <div class="brand-text">
                <span class="brand-name">金电保电子保函服务平台</span>
                <span class="brand-url">
                  <span v-for="(character, index) in 'WWW.JDBSK.COM'" :key="index">{{ character }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="flow-root">
            <a
              class="site-nav-link float-left w-20 pt-10 pl-6 text-base font-medium leading-10 text-black"
              :class="{ 'is-active': $route.path === '/index' }"
              :aria-current="$route.path === '/index' ? 'page' : null"
              @click="clickSilder('#col')"
              >首页</a
            >
             <a
              class="site-nav-link float-left pt-10 pl-6 text-base font-medium leading-10 text-black w-28"
              :class="{ 'is-active': $route.path === '/contract_check' }"
              :aria-current="$route.path === '/contract_check' ? 'page' : null"
              @click="$router.push('/contract_check')"
              >保函查验</a
            >

            <a
              class="site-nav-link float-left w-40 pt-10 pl-6 text-base font-medium leading-10 text-black"
              :class="{ 'is-active': isOrderPage }"
              :aria-current="isOrderPage ? 'page' : null"
              @click="$router.push('/admin/p_contract')"
              >保函订单</a
            >

            <div class="float-right pt-7">
              <UserDrop></UserDrop>
            </div>
          </div>
          <Login :visible="loginFlag" @cancel="cancelLogin"></Login>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import Login from './login/login.vue';
  import UserDrop from './userdrop.vue';

  export default {
    name: 'Header',
    components: { Login, UserDrop },
    computed: {
      ...mapState('user', ['loginFlag']),
      isOrderPage() {
        return ['/admin/p_contract', '/admin/team_performance'].includes(this.$route.path);
      },
    },
    watch: {
      '$route.query'(a) {
        if (a.anch) {
          setTimeout(() => {
            this.clickSilder(a.anch);
          }, 50);
        }
      },
    },
    methods: {
      clickSilder(anchro) {
        if (this.$route.path !== '/index') {
          this.$router.push({ path: '/', query: { anch: anchro } });
        }
      },
      cancelLogin() {
        this.$store.commit('user/SET_LOGINFLAG', false);
      },
    },
  };
</script>

<style lang="less" scoped>
  .brand-text {
    display: flex;
    flex-direction: column;
    width: max-content;
  }

  .brand-name {
    white-space: nowrap;
  }

  .brand-url {
    display: flex;
    justify-content: space-between;
    color: #666;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
  }

  .layout-header {
    position: relative;
    z-index: 20;
    margin-bottom: 0;

    .site-nav-link {
      position: relative;
      color: #34465c;
      text-decoration: none;

      &:hover,
      &.is-active {
        color: #0960bd;
      }

      &.is-active::after {
        position: absolute;
        bottom: 0;
        left: 24px;
        width: 24px;
        height: 3px;
        border-radius: 2px;
        background: #0960bd;
        content: '';
      }
    }
  }

  .headershadow {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.06);
  }
</style>
